import React from 'react'
import { connect } from 'react-redux'
import WarehouseActions from '../../Redux/WarehouseRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class CreateWarehouse extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.state = {
      form: {
        name: '',
        address: '',
        detail_info: ''
      }
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.form }
    data.iso_code = this.branch
    this.props.createWarehouse(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Create Warehouse</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Warehouse Name</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Warehouse Name'
                className='form-control'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Address</label>
            </div>
            <div className='col-9'>
              <textarea
                required
                rows='3'
                placeholder='Warehouse Address'
                className='form-control'
                value={this.state.form.address}
                onChange={(event) => this._inputChange(event, 'address')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Detail</label>
            </div>
            <div className='col-9'>
              <textarea
                required
                rows='3'
                placeholder='Warehouse Details'
                className='form-control'
                value={this.state.form.detail_info}
                onChange={(event) => this._inputChange(event, 'detail_info')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  createWarehouse: (data) => dispatch(WarehouseActions.createWarehouseRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateWarehouse)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/CreateWarehouse.js